import { Component, OnInit } from '@angular/core';
import { DataViewLazyLoadEvent, DataViewModule } from 'primeng/dataview';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { UsersForImpersonationFieldsFragment, UsersForImpersonationGQL } from '../graphql/gql';
import { FormsModule } from '@angular/forms';
import { ImpersonationService } from '../services/impersonation.service';

@Component({
  selector: 'app-impersonatable-user-search',
  imports: [DataViewModule, ButtonModule, InputTextModule, FormsModule],
  templateUrl: './impersonatable-user-search.component.html',
  styleUrl: './impersonatable-user-search.component.css',
})
export class ImpersonatableUserSearchComponent implements OnInit {
  users: UsersForImpersonationFieldsFragment[] = []
  totalRecords = 0;
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 50];
  isLoading = true;
  query = "";

  constructor(
    private usersForImpersonationGQL: UsersForImpersonationGQL,
    private impersonationService: ImpersonationService,
  ) { }

  ngOnInit() {
    this.newSearch()
  }

  newSearch() {
    this.loadData(1, true)
  }

  loadData(pageIndex: number, count: boolean = false): void {
    this.isLoading = true;

    const first = pageIndex * this.pageSize
    const last = this.pageSize
    const query = this.query.trim();

    this.usersForImpersonationGQL.fetch({ query, first, last, count }).subscribe((result) => {
      this.users = result.data.usersForImpersonation?.nodes?.filter(u => u != null) || []

      const totalCount = result.data.usersForImpersonation?.totalCount
      if(totalCount !== undefined && totalCount !== null) {
        this.totalRecords = totalCount;
      }
      
      this.isLoading = false;
    })
  }

  onLazyLoad(event: DataViewLazyLoadEvent) {
    const pageIndex = (event.first! / event.rows!) + 1
    this.pageSize = event.rows!
    this.loadData(pageIndex, false)
  }

  async impersonateUser(userId: string) {
    this.impersonationService.impersonateUser(userId);
  }
}
